module.exports = __webpack_public_path__ + "img/prizes.dd1774a.png";